/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export var NbToastStatus;
(function (NbToastStatus) {
    NbToastStatus["SUCCESS"] = "success";
    NbToastStatus["INFO"] = "info";
    NbToastStatus["WARNING"] = "warning";
    NbToastStatus["PRIMARY"] = "primary";
    NbToastStatus["DANGER"] = "danger";
    NbToastStatus["DEFAULT"] = "default";
})(NbToastStatus || (NbToastStatus = {}));
var NbToast = /** @class */ (function () {
    function NbToast() {
    }
    return NbToast;
}());
export { NbToast };
//# sourceMappingURL=model.js.map